// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__ZZDkZ","inputWrap":"Table_inputWrap__2B-OF","col":"Table_col__2ad9y","bmiTooltip":"Table_bmiTooltip__19LBX"};